<script>
    import { register } from 'swiper/element/swiper-element';
    import { ideas, stackIndex } from '../../../store';
    import { onMount, tick } from 'svelte';
    
    import Card from '../../molecules/Card/Card.svelte';
    import Loader from '../../atoms/Loader.svelte';
    
    export let page;
    export let tab;
    export let loading;

    let swiperEl;

    onMount(() => {
        register();
    })

    export const startOver = () => {
        $stackIndex[tab] = 0;
        swiperEl.swiper.slideTo(0)
    }

    const onSlideChange = (e) => {
        $stackIndex[tab] = e.detail[0].activeIndex;
    }

    const updateSwiper = async () => {
        await tick();
        swiperEl.swiper.update()
    }

    $: if (swiperEl && Object.keys($ideas[tab].entries).length) updateSwiper();

</script>

<style lang="scss" src="./CardSlider.scss"></style>

<div class="CardSlider">
    {#if loading}
        <Loader />
    {:else}
        {#if Object.keys($ideas[tab].entries).length}
            <swiper-container
                bind:this={swiperEl}
                on:slidechange={onSlideChange}
                direction={'vertical'}
                space-between={10}
                initial-slide={$stackIndex[tab]}>
                {#each Object.keys($ideas[tab].entries) as docId, index}
                    <swiper-slide>
                        <Card 
                            {docId}
                            uid={$ideas[tab].entries[docId].uid}
                            title={$ideas[tab].entries[docId].title}
                            text={$ideas[tab].entries[docId].text}
                            timestamp={$ideas[tab].entries[docId].timestamp}
                            media={$ideas[tab].entries[docId].media}
                            isSecured={$ideas[tab].entries[docId].isSecured}
                            saveCount={$ideas[tab].entries[docId].saveCount}
                            messageCount={$ideas[tab].entries[docId].messageCount}
                            page={page}
                        />
                    </swiper-slide>
                {/each}
                <swiper-slide class="CardSlider__end">
                    <p class="messages">That's it for now! <span class="fakelink" on:click={startOver}>Start over</span></p>
                </swiper-slide>
            </swiper-container>
        {:else}
            <p class="messages">
                No entries yet
            </p>
        {/if}
    {/if}
</div>
